// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"263":"token-tax-grant","277":"clients","594":"user-profile","945":"dashboard"}[chunkId] || chunkId) + "." + {"263":"d7dd40a8","277":"d7dd40a8","594":"d7dd40a8","688":"284a81dd","945":"d7dd40a8","972":"5e752324"}[chunkId] + ".chunk.css";
};